import { getDraftsPaginated } from '../../services/Draft'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

export const useDraftsPaginated = (page, date, name, status) => {
  const queryClient = useQueryClient()

  useEffect(() => {
    const channel = new BroadcastChannel('drafts_channel')
    channel.onmessage = (event) => {
      if (event.data?.type === 'DRAFT_UPDATED') {
        queryClient.invalidateQueries({ queryKey: ['drafts', 'get-list'] })
      }
    }
    return () => channel.close()
  }, [queryClient])

  return useQuery({
    queryKey: ['drafts', 'get-list', page, date, name, status],
    queryFn: () => getDraftsPaginated(page, date, name, status)
  })
}
